import React, { Component } from 'react';
import { Table,Button,Input, Row, Col,Select,Menu,Icon,Modal,Form,DatePicker,message,Radio, Breadcrumb} from 'antd';
import { ONLINESTATUS } from '../../../utils/questionManageType';

import {action} from './'
import { connect } from 'react-redux';
import axios from 'axios';
import $ from '$';
import API from '../../../API/api';
import CreateTask from "./creat_task/view";

const Search = Input.Search;
const Option = Select.Option;
const confirm = Modal.confirm;



class MissionList extends Component{
    state={

        search:'',
        page:1,
        pagesize:20,

        albumList:[],
        visible:false,
        totalWidth:1002,
        current:'-1',

    }
    columns=[
        //1
        {
            title: '专辑ID',
            dataIndex: 'album_id',
            key: 'album_id',
            width:80,
            fixed: 'left'
        },
        //2
        {
            title: '专辑名',
            dataIndex: 'name',
            key: 'name',
            width:210,
        },
        //3
        {
            title: '专辑封面图(4:3)',
            dataIndex: 'album_cover_img_4_3',
            key: 'album_cover_img_4_3',
            width:120,
            render: (text,record) => (
                <img style={{width:60,height:45}} src={record.album_cover_img_4_3} alt="" onClick={()=>{this.setState({modalSrc:record.album_cover_img_4_3})}}/>
            )
        },
        //4
        {
            title: '专辑封面图(16:9)',
            dataIndex: 'album_cover_img_16_9',
            key: 'album_cover_img_16_9',
            width:120,
            render: (text,record) => (
                <img style={{width:80,height:45}} src={record.album_cover_img_16_9} alt=""onClick={()=>{this.setState({modalSrc:record.album_cover_img_16_9})}}/>
            )
        },
        //5
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
            width:100,
            render: (text,record) => (
                <div>
                    <div>{record.create_time&&record.create_time.split&&record.create_time.split(' ')[0]}</div>
                    <div>{record.create_time&&record.create_time.split&&record.create_time.split(' ')[1]}</div>
                </div>
            )

        },
        //6
        {
            title: '更新时间',
            dataIndex: 'update_time',
            key: 'update_time',
            width:100,
            render: (text,record) => (
                <div>
                    <div>{record.update_time&&record.update_time.split&&record.update_time.split(' ')[0]}</div>
                    <div>{record.update_time&&record.update_time.split&&record.update_time.split(' ')[1]}</div>
                </div>
            )
        },

        //7
        {
            title: '创建人',
            dataIndex: 'create_user',
            key: 'create_user',
            width:80,
            render: (text,record) => (
                <span>{record.create_user.name}</span>
            )
        },
        //8
        {
            title: '配音数',
            dataIndex: 'video_count',
            key: 'video_count',
            width:80,
        },

        //9
        {
            title: '上线状态',
            dataIndex: 'online_status',
            key: 'online_status',
            width:90,
            render: (text, record) => (
                <span>{ONLINESTATUS[record.online_status]}</span>
            )
        },
        {
            title: <span>操作</span>,
            width:240,
            render: (text, record) => (
                <div>
                    <div>
                        {
                            this.props.user.role_album.buttons.test===1 &&
                            <a style={{cursor:'pointer'}} onClick={()=>{this.setState({preview_type:'qa',visibleOnTest:true,Modal_album_id:record.album_id})}}>上测试</a>
                        }
                        &nbsp;
                        {
                            this.props.user.role_album.buttons.online===1 &&
                            <a style={{cursor:'pointer'}} onClick={()=>{this.online(record.album_id)}}>上线</a>
                        }

                    </div>
                    <div>
                        {
                            this.props.user.role_album.buttons.edit===1 &&
                            <a style={{cursor:'pointer'}} onClick={()=>{this.onEditTask(record.album_id)}}>编辑</a>
                        }

                        &nbsp;
                        {
                            this.props.user.role_album.buttons.offline===1 &&
                            <a style={{cursor:'pointer'}}  onClick={()=>{this.offline(record.album_id)}}>下线</a>
                        }

                    </div>
                </div>
            )
        },
    ]
    inited = false

    componentWillUpdate(newProps){
        if((this.props.user!=newProps.user)||(newProps.user&&!this.inited)) {
            this.inited = true

            this.getTastList()


        }
    }
    componentDidMount(){
        this.forceUpdate()

    }

    online = (album_id)=>{
        let data ={
            album_id
        }
        axios.post(API.ALBUM_ONLINE, data).then((res)=>{
            res = res.data;
            if (res.code === 0) {
                message.success('成功 次日生效');
                this.getTastList()
            }else{
                message.error(res.message);
            }
        },()=>{message.error("网络错误！")})
    }
    offline = (album_id)=>{
        let data ={
            album_id
        }
        axios.post(API.ALBUM_OFFLINE, data).then((res)=>{
            res = res.data;
            if (res.code === 0) {
                message.success('成功 次日生效');

                this.getTastList()
            }else{
                message.error(res.message);
            }
        },()=>{message.error("网络错误！")})
    }
    onlineTestAssist= (id)=>{//上测试
        let data ={
            album_id:id,
            preview_type:this.state.preview_type,
        }
        axios.post(API.ALBUM_TEST, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getTastList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    getTastList = (callback)=>{
        setTimeout(()=>{
            let data = {
                page:this.state.page,
                pagesize:this.state.pagesize,
                search:this.state.search,
                online_status:this.state.current
            }
            axios.post(API.ALBUM_PAFGE_LIST, data).then((res)=>{
                res = res.data;
                if (res.code === 0) {
                    this.setState({albumList:res.data.list||[],total:res.data.total})
                    callback&&callback()
                }else{
                    message.error(res.message);
                }
            },()=>{message.error("网络错误！")})
        },0)


    }
    refresh = ()=>{
        this.setState({search:'',page:1,})
        setTimeout(()=>{
            this.getTastList()
        },0)

    }
    // showDeleteConfirm = () => {
    //     const me = this;
    //     confirm({
    //         title: '确定删除任务？',
    //         content: '删除任务后不可恢复，确定删除吗？',
    //         onOk() {
    //             return new Promise((resolve, reject) => {
    //                 axios.post(API.EVALUATION_TASK_DEL, {task_id:ids}).then((res)=>{
    //                     res = res.data;
    //                     if (res.code === 0) {
    //                         message.success("删除成功！");
    //                         resolve();
    //                         me.getTastList();
    //                     }else{
    //                         message.error(res.message);
    //                         reject();
    //                     }
    //                 },()=>{message.error("删除失败！")})
    //             })
    //         },
    //         onCancel() {},
    //     });
    // }
    onAddTask = () => {//创建任务修改任务
        this.setState({visible:true,albumId:''})

    }
    onEditTask = (albumId) => {//创建任务修改任务
        this.setState({visible:true,albumId})

    }

    onCancel = () => {
        this.setState({visible:false})
    }
    handleClick = (e) => {
        this.setState({current:e.key})
        setTimeout(()=>{this.getTastList()},0)
    }
    onPageChange = (val) => {
        this.setState({page:val})
        this.getTastList()
        document.querySelector('.questionListScroll').scrollTop=0
    }
    onSearch = () => {
        this.setState({page:1})
        this.state.page = 1
        this.getTastList()
    }



    render(){
        let role_album = this.props.user.role_album
        if(!role_album){return null}
        const data = [];
        this.state.albumList && this.state.albumList.forEach((val)=>{
            val.key = val.album_id
            data.push(val);
        })



        let width = 0;
        this.state.totalWidth=width+90
        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>知识点教辅管理</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>专辑管理</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={24}>
                        {
                                <div className={'searchHead'}>
                                    <Row style={{marginBottom:5}}>
                                        <Search
                                            placeholder="输入关键字"
                                            style={{ width: 220,marginLeft:20}}
                                            onSearch={this.onSearch}
                                            onChange={(e)=>this.setState({search:e.target.value})}
                                            value={this.state.search}
                                        />
                                        <Button style={{fontSize: 12,marginLeft:'20px'}} type="primary" onClick={this.onSearch}>搜索</Button>
                                    </Row>
                                </div>
                        }
                    </Col>
                </Row>
                <Row style={{marginTop:10,maxWidth:1280}}>
                    <Col span={24}>
                        <div style={{fontSize:12}}>
                            <Menu
                                onClick={this.handleClick}
                                selectedKeys={[this.state.current]}
                                mode="horizontal"
                                style={{marginBottom:5,backgroundColor:'#f7f7f7',padding:'0 15px',borderRadius:6}}
                            >
                                {
                                    <Menu.Item key="-1">全部</Menu.Item>
                                }
                                {/*{*/}
                                    {/*<Menu.Item key="0">不上线</Menu.Item>*/}
                                {/*}*/}
                                {
                                    <Menu.Item key="1">待上线</Menu.Item>
                                }
                                {
                                    <Menu.Item key="2">已上线</Menu.Item>
                                }
                                {/*{*/}
                                    {/*<Menu.Item key="3">待下线</Menu.Item>*/}
                                {/*}*/}
                                {/*{*/}
                                    {/*<Menu.Item key="4">已下线</Menu.Item>*/}
                                {/*}*/}

                            </Menu>
                        </div>
                    </Col>

                </Row>
                <Row style={{marginBottom:5,maxWidth:1280}}>
                    {
                        role_album.buttons.add===1 &&
                        <Button style={{fontSize: 12,marginRight:10}} type="primary" onClick={this.onAddTask}>创建任务</Button>
                    }
                    {this.state.visible && <CreateTask subject={this.props.user.subject} onCancel={this.onCancel} visible={this.state.visible} albumId={this.state.albumId} refresh={()=>{this.setState({page:1});setTimeout(()=>{this.getTastList()},0)}}/>}

                </Row>
                <Row style={{maxWidth:this.state.totalWidth,minWidth:'100%'}}>
                    <Table columns={this.columns} dataSource={data} pagination={{showQuickJumper:true,current:this.state.page,pageSize:+this.state.pagesize,total:~~this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth }}/>
                </Row>
                <Modal visible={this.state.visibleOnTest}
                       onOk={(e) => {this.onlineTestAssist(this.state.Modal_album_id);this.setState({visibleOnTest:false})}}
                       onCancel={() => {
                           this.setState({visibleOnTest: false})}}>
                    <Radio.Group onChange={(e)=>{this.setState({preview_type:e.target.value});}} value={this.state.preview_type}>

                        <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'jiaoyan'}>教研环境</Radio>
                        <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'dev'}>开发环境</Radio>
                        <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'qa'}>QA环境</Radio>

                    </Radio.Group>
                </Modal>
                <Modal visible={!!this.state.modalSrc}
                       footer={''}
                       className={'ModalImage'}
                       onCancel={() => this.setState({modalSrc: false})}>
                    <img src={this.state.modalSrc} alt="" onClick={() => this.setState({modalSrc: false})}/>
                </Modal>
            </div>
        );
    }
}
const mapStateTopProps = (state) => {
    return {
        user:state.user,
    };
}
const mapDispatchToProps = dispatch => {
    return {
    }
};

export default connect(mapStateTopProps,mapDispatchToProps)(MissionList);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/album/view.js